import React from 'react';
import PropTypes from 'prop-types';
import './ehrField.scss';

// The single labelled-control wrapper for the EHR drawer's custom schema
// components. A programmatic label bound to the control's id, with the required
// marker hidden from assistive technology because required state is exposed on
// the control itself.
//
// Shared deliberately: an `aria-label` that restates the visible text is easy to
// let drift from it, and a label that is not bound to its control is not
// clickable. Owning both in one place means neither can regress per component.
const EhrField = ({
  children, controlId, label, required,
}) => (
  <div className="ehr-field">
    <label className="ehr-field__label" htmlFor={controlId}>
      {label}
      {required && <span aria-hidden="true"> *</span>}
    </label>
    {children}
  </div>
);

EhrField.propTypes = {
  children: PropTypes.node.isRequired,
  controlId: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  required: PropTypes.bool,
};

EhrField.defaultProps = { required: false };

export default EhrField;
